export enum CostType {
  PATIENT_INVOICEABLES = 'Patient Invoiceables',
  PATIENT_VISITS = 'Patient Visits',
  SITE_INVOICEABLES = 'Site Invoiceables',
}
